import { Box } from "@mui/material";
import QRCode from "react-fancy-qrcode";
import {
  BackIconNew,
  CloseIcon,
  CopyIconNew,
  InfoIcon,
  SuccessPayment,
  Whatsapp,
} from "../../../../assets/icons/icon";
import LogoRupin from "../../../../assets/icons/Logo Rupin.svg";
import { ParagraphText, UBAppModal, UBButton } from "../../../../Libraries";
import { useContext, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import styles from "./styles.module.css";
import uCashStyles from "../../../Features/UCash/styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const APP_DOWNLOAD_LINK =
  "https://play.google.com/store/apps/details?id=com.oscarudhaarapp&hl=en";

const WalletNonidealModal = ({
  isPending,
  setOpen,
  open,
  applicationID,
  raastDetail,
  isVerificationFailed,
  modalTitle = "upgrade_account",
  isShowWhatsapp = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleClose = () => {
    triggerLogEvent(analytics, "w_wallet_kyc_modal_closed");
    setOpen(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(APP_DOWNLOAD_LINK);
      triggerLogEvent(analytics, "w_wallet_kyc_copy_link");
      setIsLinkCopied(true);
      setTimeout(() => setIsLinkCopied(false), 1500);
    } catch (error) {
      console.error(error);
    }
  };

  const handleShareLink = () => {
    triggerLogEvent(analytics, "w_wallet_kyc_share_link");
    const message = encodeURIComponent(
      `${I18n.upgrade_account_download_desc || ""}\n${APP_DOWNLOAD_LINK}`.trim()
    );
    window.open(`https://web.whatsapp.com/send?text=${message}`, "_blank");
  };

  return (
    <UBAppModal
      id="wallet_nonideal_modal"
      open={open}
      className={`${styles.upgradeAccountModal} ${
        isPending ? "walletPending" : ""
      }`}
      header={{
        handleClose: handleClose,
        dont_show_cross_icon: true,
        title: isPending ? undefined : modalTitle,
        CustomHeader: isPending ? (
          <div className="HeaderModal">
            <div className="modalTitle" />            
          </div>
        ) : undefined,
      }}
    >
      {isPending ? (
        <Box className="row justify-content-center h-100">
          <Box className={uCashStyles.transactionSuccessContentBox}>
            <Box textAlign={"center"} mb={"0.75rem"}>
              <SuccessPayment />
            </Box>
            <ParagraphText align="center" className={"fontSize24 fontWeight500"}>
              {I18n.application_completed}
            </ParagraphText>
            <div className="marginBottom6" />
            <ParagraphText
              align="center"
              className="fontSize16 foundationInk300"
            >
              {`${I18n.application_ID}: ${applicationID} | ${I18n.account_number}: ${raastDetail?.raast_details?.account_number}`}
            </ParagraphText>
            <ParagraphText className={"accountActivation"}>
              {I18n.account_activation}:&nbsp;
              <ParagraphText className={"foundationYellowNormal"}>
                {I18n.pending}
              </ParagraphText>
            </ParagraphText>
            <ParagraphText
              align="center"
              className={"d-flex justify-content-center fontSize16px"}
            >
              {I18n.your_account_will_be_activated_in} &nbsp;
              <ParagraphText className={"fontWeight500"}>
                10 - 15 &nbsp;{I18n.minutes}
              </ParagraphText>
            </ParagraphText>
          </Box>
        </Box>
      ) : (
        <Box className={styles.WalletNonidealContainer}>
          {isVerificationFailed && (
            <Box className="infoAlertBox">
              <InfoIcon />
              <ParagraphText className={"fontSize14"}>
                Verification failed, try again
              </ParagraphText>
            </Box>
          )}

          <ParagraphText className={styles.subtitle}>
            {I18n.scan_qr_or_share_download_link}
          </ParagraphText>

          <Box className={styles.QRContainer}>
            <Box className={`${styles.QRContainerInner} qrContrastSurface`}>
              <QRCode
                value={APP_DOWNLOAD_LINK}
                size={180}
                dotRadius="12%"
                dotScale={1}
                positionRadius={5}
                logo={LogoRupin}
              />
            </Box>
          </Box>

          <Box className={styles.actionRow}>
            <UBButton
              id="wallet_nonideal_copy_link"
              title={isLinkCopied ? I18n.copied : I18n.copy_link}
              onClick={handleCopyLink}
              iconComponent={<CopyIconNew width={16} height={16} />}
              className={`${styles.copyLinkBtn} ubButtonStyle ubSecondaryButton textUppercase`}
            />
            <UBButton
              id="wallet_nonideal_share_link"
              title={I18n.share_link}
              onClick={handleShareLink}
              iconComponent={<Whatsapp width={16} height={16} />}
              className={`${styles.shareLinkBtn} ubButtonStyle ubPrimaryButton textUppercase`}
            />
          </Box>

          <ParagraphText className={styles.footerText}>
            {I18n.upgrade_account_download_desc}
          </ParagraphText>

          {isShowWhatsapp && (
            <Box className={styles.needHelpRow}>
              <Whatsapp width={20} height={20} />
              <ParagraphText className={styles.needHelpText}>
                {I18n.need_help}{" "}
                <a
                  href="https://wa.me/923411141000"
                  target="_blank"
                  rel="noreferrer"
                  className={styles.needHelpPhone}
                >
                  +92 341 1141000
                </a>
                <BackIconNew width="20px" height="20px" />
              </ParagraphText>
            </Box>
          )}
        </Box>
      )}
    </UBAppModal>
  );
};

export default WalletNonidealModal;
